import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import './terms.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>利用規約 | 株式会社TERRA</title>
      </Helmet>
      <div className="terms">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          利用規約
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>利用規約</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <br />
          <p>
            定期便の申し込みに先立ち、定期便ご利用規約（以下「本規約」といいます。）
            をよくお読み頂き、内容について同意された上で、定期便をご利用下さい。
            <br />
            同定期便について申込をされました以降は、本規約全てについてご承諾頂いたものとみなします。
          </p>
          <p className="text_title">第1条（目的・適用）</p>
          <p>
            <ol className="numberList">
              <li>本規約は、株式会社TERRA（以下「当社」という。）が提供する加湿器の使用貸借及び液剤の売買（定期便）について、利用の諸条件を定めるものです。</li>
              <li>本規約のほか、当社とお客様で別途個別条件を定めた場合は、本規約と同個別条件にて抵触があるときは、同個別条件を優先いたします。</li>
            </ol>
          </p>
          <p className="text_title">第2条（加湿器の使用貸借）</p>
          <p>
            <ol className="numberList">
              <li>本規約は、株式会社TERRA（以下「当社」という。）が提供する加湿器の使用貸借及び液剤の売買（定期便）について、利用の諸条件を定めるものです。</li>
              <li>本規約のほか、当社とお客様で別途個別条件を定めた場合は、本規約と同個別条件にて抵触があるときは、同個別条件を優先いたします。</li>
            </ol>
          </p>

          <p className="text_title">第3条（使用貸借の条件等）</p>
          <p>
            <ol className="numberList">
              <li>
                当社は、その所有に係る加湿器（以下「本件加湿器」という。）を、
                次条以下の約定でお客様に貸し渡し、無償で使用、収益をなすことを約し、当社は、
                <br />
                これを承諾したうえ、本契約が終了したときに返還することを約した。
                ただし、当社は、時期に関わらず、無償で貸す物件を変更することができる。
              </li>
            </ol>
          </p>
          <p className="text_title">第４条（本件液剤の継続的売買）</p>
          <p>
            <ol className="numberList">
              <li>
                本件加湿器にかかる本契約の期間は、
                当社がお客様に販売する液剤（以下「本件液剤」という。）
                の売買契約が終了するまでとします。
              </li>
              <li>
                貸し渡す本件加湿器の個数は、
                お客様が当社から購入する本件液剤の個数以下で、
                お客様が当社に申し込んだ個数とします。
              </li>
              <li>
                お客様は、善良なる管理者の注意義務を持って本件加湿器を保管及び使用、
                収益し、本件加湿器の用法に従い使用、収益しなければなりません。
              </li>
              <li>
                お客様は、本件液剤を使用する目的でのみ本件加湿器を使用することができ、
                同目的以外で使用することはできません。
              </li>
              <li>
                お客様は、本件加湿器を第三者に使用、収益させてはなりません。
              </li>
              <li>
                お客様がその責めに帰すべき事由により本件加湿器を滅失又は毀損したときは
                、お客様が被った損害を直ちに賠償しなければなりません。ただし、事情を考慮して、
                当社の独自の判断により、この義務の全部又は一部を免除すること、
                若しくは別の加湿器の提供をすることができます。
              </li>
            </ol>
          </p>

          <p className="text_title">第5条（売買契約の解除等）</p>
          <p>
            <ol className="numberList">
              <li>お客様は、当社に対して、本件液剤を申込画面にてご確認頂いた条件で継続的に買い受ける申込を行いました。</li>
              <li>
                当社が、お客様の申込を承諾したときに契約が成立します。ただし、
                申込の翌日から起算して３日経過までに承諾しないことを通知しない場合は、
                申込の同３日を経過したときに契約が成立したものとみなします。
              </li>
              <li>
                お支払は、お客様が申込時に選択頂いた方法によりお支払頂きます。
                <br />
                口座振替ご希望の方は、登録制ですので、事前のご利用手続きをいたしますので、
                ご希望の方は必要書類の送付をお電話、インターネット、メールにてお申しつけ下さい。
                銀行振込又はコンビニ払いを選択された方は、本件商品到着後、10日以内に同封の書類を使用して、
                選択された方法によりお支払い頂くようお願いいたします。
              </li>
            </ol>
            <p style={{ marginBottom: '0' }}>売買対象商品概要</p>
            <table className="table-bordered">
              <tbody>
                <tr>
                  <th style={{ width: '35%' }}>商品の種類</th>
                  <td style={{ width: '65%' }}>殺菌目的のために本件加湿器に入れて使用する液剤</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>商品名</th>
                  <td style={{ width: '65%' }}>申込いただいた定期便商品</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>商標又は製造業者名</th>
                  <td style={{ width: '65%' }}>TERRAFORESTA・Mist　（株）TERRA</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>販売単価</th>
                  <td style={{ width: '65%' }}>申込時にご確認頂いた金額</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>送料</th>
                  <td style={{ width: '65%' }}>北海道・沖縄を除く全国一律1,200円（税込）、北海道・沖縄は2,000円（税込）</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>数量</th>
                  <td style={{ width: '65%' }}>申込頂いた個数</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>引渡時期</th>
                  <td style={{ width: '65%' }}>契約が終了するまで毎月１回、毎月10日に発送</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>返品等</th>
                  <td style={{ width: '65%' }}>申込撤回不可。解約は申込の翌月から6カ月目以降可能。</td>
                </tr>
              </tbody>
            </table>
            <br />
            <p style={{ marginBottom: '0' }}>売買対価の支払方法</p>
            <table className="table-bordered">
              <tbody>
                <tr>
                  <th style={{ width: '35%' }}>支払時期</th>
                  <td style={{ width: '65%' }}>申込時に確認頂いた時期</td>
                </tr>
                <tr>
                  <th style={{ width: '35%' }}>支払方法</th>
                  <td style={{ width: '65%' }}>
                    お客様が申込時に選択頂いた方法によりお支払い頂きます。
                    <br />
                    □ クレジットカード
                  </td>
                </tr>
              </tbody>
            </table>
          </p>
          <p className="text_title">第6条（債権の譲渡）</p>
          <p>
            1.お客様は、当社の書面による承諾を得ない限り、当社に対する債権を第三者に譲渡することができません。
          </p>

          <p className="text_title">第7条（所有権移転及び危険負担）</p>
          <p>
            1.本件液剤の所有権は、本件液剤の受渡しがあった時に、当社からお客様に移転するものとします。
            <br />
            2.本件液剤の引渡し前に生じた本件液剤の滅失、毀損、減量、変質その他一切の損害は、
            お客様の責めに帰すべきものを除き、当社の負担とし、
            本件液剤の引渡し後に生じたこれらの損害は、当社の責めに帰すべきものを除き、お客様の負担とします。
          </p>

          <p className="text_title">第8条（遅延損害金）</p>
          <p>
            1.お客様が売買代金債務の弁済を怠ったときは、当社に対し支払期日の翌日より完済の日まで年14％の割合による遅延損害金を支払うものとします。
          </p>

          <p className="text_title">第9条（担保責任）</p>
          <p>
            <ol className="numberList">
              <li>
                当社は、本件液剤の契約条件との相違又は引渡し前の原因によって生じた本件液剤の品質不良、
                数量不足、変質その他契約内容との不適合につき責めに任ずるものとし、
                お客様は、まずは、代替物の引渡し又は不足分の引渡しによる履行の追完を請求することができます。
                ただし、当社は、お客様に不相当な負担を課するものでないときは、
                お客様が請求した方法と異なる方法による履行の追完をすることができる。
                同不適合がお客様の責めに帰すべき事由によるものであるときは、
                お客様は、履行の追完の請求をすることができません。
              </li>
              <li>
                前項に規定する場合において、お客様が相当の期間を定めて履行の追完の催告をし、
                その期間内に履行の追完がないときは、お客様は、その不適合の程度に応じて代金の減額を請求することができます。
                前項の不適合がお客様の責めに帰すべき事由によるものであるときは、お客様は、代金の減額の請求をすることができません。
              </li>
              <li>
                前二項の規定は、民法規定の契約不適合責任に基づく請求権ないし解除権の行使を妨げません。
                但し、お客様は直ちに発見し得る契約不適合については、物品の受領後、遅滞なく検査を行い、
                かつ、検査後、直ちに適合しない旨の通知を発しない場合には、その解除権又は請求権を失うものとします。
              </li>
            </ol>
          </p>

          <p className="text_title">第10条（期限の利益の喪失）</p>
          <p>
            <ol className="numberList">
              <li>
                下記の各号の場合には、当社の請求を受けたときは、お客様は直ちに債務の全額を一時に弁済しなければなりません。
                <ol className="bracket">
                  <li>お客様が当社に対する売買代金支払債務その他一切の債務又は本契約以外の契約上の債務につき支払義務を怠ったとき</li>
                  <li>
                    お客様が差押え、仮差押え、仮処分、公売処分、租税滞納処分、その他公権力の処分を受け、
                    又は、破産手続の開始若しくは競売を申し立てられ、又は自ら、破産手続開始の申立てをしたとき
                  </li>
                  <li>お客様が監督官庁より営業停止又は営業免許若しくは営業登録の取消しの処分を受けたとき</li>
                  <li>お客様が営業の廃止若しくは変更をしたとき</li>
                  <li>お客様が自ら振出し若しくは引き受けた手形又は小切手につき不渡処分を受ける等支払停止状態に至ったとき</li>
                  <li>お客様が本契約の条項に違反したとき</li>
                  <li>その他お客様の財産状態が悪化し、又はそのおそれがあると認められる相当の事由があるとき</li>
                </ol>
              </li>
            </ol>
          </p>

          <p className="text_title">第11条（即時解除）</p>
          <p>
            <ol className="numberList">
              <li>
                お客様において第10条各号の一に該当する事実が発生したときは、
                当社は催告及び自己の債務の履行の提供をしないで直ちに本契約の全部又は一部を解除することができます。
                なお、当社のお客様に対する損害賠償の請求を妨げません。
              </li>
              <li>
                お客様又は当社は、その相手方が本契約の条項に違反し、
                又は本契約及び他の契約上の債務の履行を怠ったときは、相当の期間をおいて催告を行い、
                催告をしたにも関わらず是正しないときは、本契約の全部又は一部を解除することができます。
                なお、この場合、損害の賠償を請求することを妨げません。
              </li>
            </ol>
          </p>

          <p className="text_title">第12条（Cookie（クッキー）その他の技術の利用）</p>
          <p>
            <ol className="numberList">
              <li>
                本契約が失効し、又は解除された場合においても、
                その失効又は解除の時に現に存在する本契約に基づく契約関係、
                損害賠償請求等の現存する権利関係については、
                なお、この契約の各条項は、その効力を失わないものとします。
              </li>
            </ol>
          </p>

          <p className="text_title">第13条（反社会的勢力の排除）</p>
          <p>
            <ol className="numberList">
              <li>
                当社及びお客様は、現在、暴力団、暴力団員、暴力団準構成員、
                暴力団関係企業、総会屋、社会運動等標榜ゴロ又は特殊知能暴力集団等、
                その他これに準ずる者（以下「反社会的勢力」という。） のいずれでもなく、
                また、反社会的勢力が経営に実質的に関与している法人等に属する者ではないことを表明し、
                かつ将来にわたっても該当しないことを確約します。
              </li>
              <li>
                当社又はお客様は、相手方が次の各号の一に該当する場合、
                何らの催告をすることなく契約を解除することができ、相手方に損害が生じてもこれを賠償することを要しません。
                <ol className="bracket">
                  <li>反社会的勢力に該当すると認められるとき</li>
                  <li>相手方の経営に反社会的勢力が実質的に関与していると認められるとき</li>
                  <li>相手方が反社会的勢力を利用していると認められるとき</li>
                  <li>相手方が反社会的勢力に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められるとき</li>
                  <li>
                    相手方又は相手方の役員若しくは相手方の経営に実質的に関与している者が反社会的勢力と
                    社会的に非難されるべき関係を有しているとき
                  </li>
                  <li>
                    自ら又は第三者を利用して、暴力的な要求行為、法的な責任を超えた不当な要求行為、
                    脅迫的な言動、暴力及び風説の流布・偽計・威力を用いた信用毀損・業務妨害その他これらに準ずる行為に及んだとき
                  </li>
                </ol>
              </li>
            </ol>
          </p>

          <p className="text_title">第14条（不可力免責）</p>
          <p>
            <ol className="numberList">
              <li>
                天災地変、戦争、暴動、内乱、法令の改廃制定、公権力による命令処分、同盟罷業その他の争議行為、
                輸送機関の事故、その他不可抗力により、契約の全部若しくは一部の履行の遅延又は引渡しの不能を生じた場合には、
                当社はその責めに任じません。
              </li>
              <li>
                この場合に、本契約は引渡不能となった部分については、
                当社の義務は消滅するものとします。
              </li>
            </ol>
          </p>
          <p className="text_title">第15条（本規約の変更）</p>
          <p>
            <ol className="numberList">
              <li>
                本規約は、株式会社TERRA（以下「当社」という。）が提供する加湿器の使用貸借及び液剤の売買（定期便）について、
                利用の諸条件を定めるものです。
              </li>
              <li>
                本規約のほか、当社とお客様で別途個別条件を定めた場合は、
                本規約と同個別条件にて抵触があるときは、同個別条件を優先いたします。
              </li>
            </ol>
          </p>
          <p className="text_title">第16条（免責）</p>
          <p>
            <ol className="numberList">
              <li>
                当社が、定期便に関連して当社の責めに帰すべき事由によりお客様に損害を与えた場合における損害賠償責任の範囲は、
                当社がお客様から定期便に関連して受領した料金の総額を上限とし、
                かつ、定期便の利用によりお客様に直接的に生じた通常損害
                （特別損害、間接損害、並びにその他の損害は予見可能性の有無に関わらず含まれません）に限定されます。ただし、
                当社に故意又は重過失がある場合はこの限りではありません。
              </li>
            </ol>
          </p>
          <p className="text_title">第17条（個人情報の利用について）</p>
          <p>
            <ol className="numberList">
              <li>
                お客様が当社に提供頂いた個人情報（名前、電話番号、住所、性別、お申込み内容等）は、
                商品や資料の発送、各種ご連絡、アンケートやお問合せ、当社が行う各種サービスの提供及びそのご案内・
                ダイレクトメール等に使用させていただきます。お客様の承諾なく、その他の目的には利用いたしません。
              </li>
            </ol>
          </p>
          <p className="text_title">第18条（準拠法及び合意管轄）</p>
          <p>
            <ol className="numberList">
              <li>本規約及び本規約に関連する一切の法律関係は日本法を準拠法とし、日本法に従って解釈されるものとします。</li>
              <li>本契約より生ずる権利義務に関する訴訟については、名古屋地方裁判所を以て専属的管轄裁判所とします。</li>
            </ol>
          </p>
          <p className="text-right">2021年2月 制定</p>
          <br />
          <br />
          <p className="text-center font-weight-bold phone_number" style={{ fontSize: '4rem', letterSpacing: '0.5rem', lineHeight: '1' }}>0120-406-520</p>
          <p className="text-center phone_time" style={{ fontSize: '1.5rem', letterSpacing: '0.2rem', marginBottom: '0' }}>24時間365日対応</p>
        </div>
      </div>
    </TheLayout>
  );
};
export default Terms;
